import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { Box, IconButton, Typography, Dialog } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { type ReactNode } from 'react'
import { color } from 'config/color'

interface IGenericDialog {
  open: boolean
  onClose: () => void
  isLoading?: boolean
  title?: string
  children: ReactNode
  iconType?: string
}

export const GenericDialog = ({
  open,
  onClose,
  isLoading,
  title,
  children,
  iconType
}: IGenericDialog): JSX.Element => {
  const isMobile = useMobileBreakpoints()

  const handleClose = (_event: any, reason: string): void => {
    if (reason === 'backdropClick') return
    onClose()
  }

  return (
    <Box>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <Box>
          <Box display="flex" justifyContent="flex-end">
            <IconButton onClick={onClose} disabled={isLoading}>
              <CloseIcon color="primary" />
            </IconButton>
          </Box>

          <Box px={4} pb={4}>
            {iconType && <DialogIcon iconType={iconType} />}

            {title && (
              <Typography
                color={color.grey[900]}
                fontSize={isMobile ? 18 : 24}
                fontWeight={500}
                textAlign="center"
                mb={3}
              >
                {title}
              </Typography>
            )}
            {children}
          </Box>
        </Box>
      </Dialog>
    </Box>
  )
}

interface IDialogIcon {
  iconType: string
}
const DialogIcon = ({ iconType }: IDialogIcon): JSX.Element => {
  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      gap={1}
      borderRadius="4px"
      alignItems="center"
      mb={3}
    >
      {iconType === 'warning' && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          bgcolor={color.warning[50]}
          p={2}
        >
          <ErrorOutlineIcon sx={{ color: color.warning[500], fontSize: 40 }} />
        </Box>
      )}

      {iconType === 'success' && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          bgcolor={color.success[50]}
          p={2}
        >
          <CheckCircleRounded
            sx={{ color: color.success[600], fontSize: 40 }}
          />
        </Box>
      )}
    </Box>
  )
}
